import React from 'react'

import { Tooltip } from '@mantine/core'

import AdminOnlyDot from 'src/components/AdminContainer/AdminOnlyDot'
import IconInfoCircle from 'src/icons/IconInfoCircle'

interface FieldLabelProps {
  label: string
  tooltip: string | React.ReactNode
  required?: boolean
  adminOnly?: boolean
}

const FieldLabel = ({
  label,
  tooltip,
  required = false,
  adminOnly = false,
}: FieldLabelProps) => (
  <div className="flex items-center gap-1">
    <span className="text-sm font-medium text-doubleNickel-gray-700">
      {label}
    </span>
    {required && <span className="text-doubleNickel-error-500">*</span>}
    <Tooltip label={tooltip} multiline maw={300} withArrow>
      <div className="flex items-center">
        <IconInfoCircle className="h-3.5 w-3.5 fill-none stroke-doubleNickel-gray-500" />
      </div>
    </Tooltip>
    {adminOnly && <AdminOnlyDot />}
  </div>
)

export default FieldLabel
